import { styled } from 'styled-components';
import {
  BlockStatic as BlockStaticComp,
  DepositAddressBonusWrapper as DepositAddressBonusWrapperCom,
} from '../../styles';
import { Button } from '@/shared/ui/form/button';
import { Image } from '@/shared/ui/image';

export const Wrapper = styled.div`
  display: flex;
  width: 460px;
  max-height: 720px;
  min-height: 660px;
  padding: 18px;
  flex-direction: column;
  gap: 3px;
  text-align: center;
  background: #131315;
  box-shadow: 0px 0px 250px 50px #131315;
  border-radius: 12px;
  border: 1px solid #131315;
  position: relative;
  ${({ $isSticky }) =>
    $isSticky &&
    `
padding-bottom:0;
`}
  ${({ $isFiat }) =>
    $isFiat &&
    `
gap:0; 
`}  

${({ $isFiatWithdraw }) =>
    $isFiatWithdraw &&
    `
  justify-content: flex-start;
    padding-bottom: 24px;

  `}

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    border-radius: 0;
    border: none;
    max-height: fit-content;
  }
`;

export const BlockStatic = styled(BlockStaticComp)``;

export const WrapperForm = styled.div`
  height: 100%;
`;

export const CurrencyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  border-radius: 8px;
  height: auto;
  overflow-y: auto;
  box-sizing: border-box;
  scroll-behavior: smooth;
`;

// export const ArrowUpIcon = styled(ArrowUp)`
//   transform: rotate(180deg);

//   path {
//     fill:${({ $active }) => ($active ? '#fff' : '#AFAFAF')};;
//   }
// `;

// export const ClockIcon = styled(Clock)`
//   path {
//     fill: ${({ $active }) => ($active ? '#fff' : '#AFAFAF')};
//   }
// `;

// export const ArrowBottomIcon = styled(ArrowUpIcon)`
//   transform: rotate(360deg);
// `;

// export const WalletButton = styled(Button)`
//   border-radius: 8px;
//   gap: 4px;
//   cursor:pointer;

//   @media (max-width: 768px) {
//     gap: 0px;
//     height: 40px;
//   }
// `;
export const PaymentBlock = styled.div`
  display: flex;
  padding: 12px;
  align-items: center;
  align-self: stretch;
  background: #27262b;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 0px;
  padding: 14px 12px;
  border-top-right-radius: ${(props) => (props.$isFirst ? '8px' : '0')};
  border-top-left-radius: ${(props) => (props.$isFirst ? '8px' : '0')};
  border-bottom-left-radius: ${(props) => (props.$isLast ? '8px' : '0')};
  border-bottom-right-radius: ${(props) => (props.$isLast ? '8px' : '0')};
`;

export const CurrencyWrapper = styled.div`
  background: #27262b;
  height: auto;
  // max-height: 426px;
  // overflow-y: auto;
  margin-top: 24px;
  border-radius: 8px;
`;

export const QrWrapper = styled.div`
  display: inline;
  background-color: #edeff5;
  border-radius: 8px 12px 0px 0px;
  position: absolute;
  padding: 16px;
  padding-top: 40px;

  left: 16px;
  right: 16px;
  max-width: 232px;
  margin: 0 auto;
  &:after {
    content: '';
    position: absolute;
    bottom: -12px;
    left: 0;
    width: 100%;
    height: 14px;
    background-image: url('/images/icons/union.svg');
    z-index: 10;
  }
`;

export const FormGroup = styled.div`
  margin-top: 74px;
  overflow-y: scroll;
  input::placeholder {
    color: #afafaf;
    opacity: 0.4;
  }
`;

export const QrContainer = styled.div`
  position: relative;
  min-height: 292px;
`;

export const AddressText = styled.div`
  word-wrap: break-word;
`;

export const DepositAddressWrapper = styled.div`
  padding: 24px;
  margin-top: 32px;
  overflow-y: auto;
`;

export const CopyButton = styled(Button)`
  margin: 0 auto;
`;

export const BottomDescriptions = styled.div`
  align-items: center;
  bottom: 16px;
  text-align: center;
  left: 0;
  width: 100%;
  margin-top: 35px;
  @media (max-width: 768px) {
    margin-top: 15px;
  }
`;

export const CurrencySearch = styled.input`
  padding: 16px;
  border: none;
  background: #27262b;
  border-radius: 20px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  color: #edeff5;
  font-size: 16px;
  width: 100%;
  outline: none;
  border-bottom: 1px solid rgb(75, 68, 76);
  padding-left: 48px;
  background-image: url(/images/icons/search-icon.svg);
  background-repeat: no-repeat;
  background-size: 24px;
  background-position: 16px center;

  &:focus {
    background-color: rgba(44, 52, 74, 0.6);
  }
  &::placeholder {
    color: #55648a;
  }
`;

export const CurrencySearchWrapper = styled.div`
  position: relative;
`;

export const ClearElement = styled(Image)`
  position: absolute;
  z-index: 100;
  right: 20px;
  top: 16px;
  cursor: pointer;
`;

export const DepositAddressBonusWrapper = styled(
  DepositAddressBonusWrapperCom
)``;

export const DepositAddressBonus = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 8px;

  position: relative;
  border-bottom: 1px solid #2c344a;

  ${({ $active }) =>
    $active &&
    `
    background-image:url('/images/background/ellipse-bonus-active.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
`}
`;

export const DepistAddressContent = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 8px;
  padding-bottom: 8px;
`;
export const BonusInfo = styled.div`
  display: flex;
  border-radius: 0px 0px 8px 8px;
  background: #fbb623;
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  display: flex;
  justify-content: center;
  padding: 4px;
  gap: 4px;
`;

export const FiatProcessingBlock = styled.div`
  border-radius: 20px;
  background: var(--2-c-344-a-40, #27262b);
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
  padding: 12px;
  text-align: left;
  align-items: center;
`;

export const BonusWrapper = styled.div`
  border-radius: 8px;
  background: #27262b;
  padding: 12px;
  // margin-top: 16px;
  text-align: left;
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
`;
